/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { theme } from '@insticator/insticator-ui';



/* ++++++++++ --------------- CARD TOGGLES : STYLES --------------- ++++++++++ */
export default {
    cardtoggles: {
        display: 'flex',
        flexWrap: 'wrap',
        height: '100%',
        width: '100%',
        marginTop: '24px'
    }
};
